package app.api

import app.client
import app.model.Deployable
import app.model.PaginatedResponse
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import kotlinx.coroutines.Job

class DeployablePaginatedApi : RootStore<PaginatedResponse<Deployable>>(
    PaginatedResponse(emptyList(), 0, 0, 0, 10),
    job = Job()
) {
    data class PaginationRequest(
        val name: String,
        val sort: String,
        val order: String,
        val page: Int,
        val pageSize: Int = 10
    )
    val handler = handle { _, req: PaginationRequest ->
        client.get(
            Routing.Deployables.Sort(
                name = req.name,
                sort = req.sort,
                order = req.order,
                page = req.page,
                size = req.pageSize,
            )
        ).body<PaginatedResponse<Deployable>>()
    }
}
